var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 26V22H44V26H36ZM38.4 40L32 35.2L34.4 32L40.8 36.8L38.4 40ZM34.4 16L32 12.8L38.4 8L40.8 11.2L34.4 16ZM10 38V30H8C6.9 30 5.95867 29.6087 5.176 28.826C4.39333 28.0433 4.00133 27.1013 4 26V22C4 20.9 4.392 19.9587 5.176 19.176C5.96 18.3933 6.90133 18.0013 8 18H16L26 12V36L16 30H14V38H10ZM22 28.9V19.1L17.1 22H8V26H17.1L22 28.9ZM28 30.7V17.3C28.9 18.1 29.6253 19.0753 30.176 20.226C30.7267 21.3767 31.0013 22.6347 31 24C30.9987 25.3653 30.7233 26.624 30.174 27.776C29.6247 28.928 28.9 29.9027 28 30.7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon4);
export default __webpack_public_path__ + "static/media/cardIcon4.f63c58941acef677b7d791468c251498.svg";
export { ForwardRef as ReactComponent };